import { QueryParams } from '@/api/requests/monitoring/interfaces';
import { useAppConstantsContext } from '@/context/AppConstants';
import { useReportMonitors } from '@/monitoring/useReportMonitors';
import { serializedTypes } from '@/reports/types';
import { Card } from '@/theme/components';
import { styled, Text, Stack } from '@/theme/index';
import MonitoringButton from '../MonitoringButton/MonitoringButton';

export const ImgMonitor = styled('img')(() => ({
  margin: 'auto',
  height: '100px',
  width: '72px',
}));

export interface MonitoringBannerProps {
  propertyReportData: serializedTypes.SerializedProperty;
  permalink: string;
  reportType: string;
}

export function MonitoringBanner({
  propertyReportData,
  permalink,
  reportType,
}: MonitoringBannerProps) {
  const {
    images: { imgMonitorBanner },
  } = useAppConstantsContext();
  const { reportIsMonitored, toggleReportIsMonitored } =
    useReportMonitors(permalink);
  const { parcel_address } = propertyReportData;
  const { city, state, zip } = parcel_address?.parts || {};

  const HandleSetIsMonitored = async () => {
    const queryParams: QueryParams = {
      'report_monitor[permalink]': permalink || '',
      'report_monitor[is_claimed]': 'false',
      'report_monitor[report_type]': reportType || '',
    };
    toggleReportIsMonitored({
      queryParams,
    });
  };

  const monitorTxt = reportIsMonitored
    ? 'Monitoring enabled'
    : 'Monitor this address';

  return (
    <Card variant="outlined">
      <Stack direction="column" alignItems="center">
        <ImgMonitor src={imgMonitorBanner} />
        <Text mt={1.25} mb={1.25} variant="h1" fontWeight="500" align="center">
          Help stay informed about the things happening in your neighborhood
        </Text>
        <Text mt={1.25} mb={2.5} variant="h3" fontWeight="500" align="center">
          Turn on monitoring for{' '}
          <strong>
            {city}, {state} {zip}
          </strong>
        </Text>
        <MonitoringButton
          handleSetIsMonitored={HandleSetIsMonitored}
          buttonLabel={monitorTxt}
          isMonitored={reportIsMonitored}
        />
      </Stack>
    </Card>
  );
}
